var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"apps"},[(!_vm.is)?_c('div',{staticClass:"toast"},[_vm._v(" 暂无内容 ")]):_c('div',{staticStyle:{"position":"relative"}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.pageData.content)}}),_c('div',{staticClass:"imgs_box"})]),_c('div',{staticClass:"back",on:{"click":function($event){return _vm.$router.back()}}},[_vm._v("返回")])])
}
var staticRenderFns = []

export { render, staticRenderFns }